const WA_PHONE = "212706280215";
const FALLBACK_MSG =
  "Hello Maroctransfers, I would like to book a transfer/tour.";

export const buildWhatsAppUrl = (message: string = FALLBACK_MSG): string =>
  `https://wa.me/${WA_PHONE}?text=${encodeURIComponent(message)}`;

export const WHATSAPP_DEFAULT_MESSAGE = FALLBACK_MSG;